import React, { forwardRef, useRef, useState } from "react";
import "./ServicesSec.scss";
import ServicesCarousel from "../ServicesCarousel";
import Service3Image from "../../assets/images/service3.png";
// import Service7Image from "../../assets/images/service7.png";
import PaintingAndDrawing from "../../assets/images/Painting&Drawing.png";
import LaserEngraving from "../../assets/images/LaserEngraving.png";
import LongRightArrow from "../../assets/images/long-right-arrow.svg";
import VirtualReality from "../../assets/images/virtual-reality.png";
import ScreenPrinting from "../../assets/images/screen-printing.png";
import ThreeDPrinting from "../../assets/images/3D-Printing.png";
import Circuit from "../../assets/images/Cricut.png";
import Podcast from "../../assets/images/podcast.png";
import Photography from "../../assets/images/photography.png";
import SewingStation from "../../assets/images/sewing-station.png";
import ComputerLab from "../../assets/images/computer-lab.png";
import CollabSpace from "../../assets/images/collab-space.png";
import WoodWorking from "../../assets/images/Woodworking.png";
import Button from "../Button";
import Slider from "react-slick/lib/slider";
import ServiceBlue1 from "../../assets/images/service_blue.svg";
import ServiceBlue2 from "../../assets/images/service_blue2.svg";
import ServiceBlue3 from "../../assets/images/service_blue3.svg";
import ServiceBlueLine from "../../assets/images/service_blueLine.svg";
import ServicesPopup from "../ServicesPopup";
import { postUserInfo } from "../../apis/backend_helper";

const ServicesData = [
  {
    picture: ThreeDPrinting, // Service7Image,
    title: "3D Printing",
    tag: "3D Printing",
    details:
      "With Bambu Lab 3D printers, young creators can bring their digital designs to life. These printers are fast, reliable, and simple to use—perfect for learning about modeling, prototyping, and how real-world products are made.",
    popup: (
      <>
        At Creator Zone, we proudly present a fleet of six cutting-edge 3D
        printers that possess the incredible ability to turn digital designs
        into tangible reality. As a member, you'll enjoy the added perk of basic
        filament included with every membership, giving you a seamless start on
        your 3D printing journey. What's more, we offer complimentary workshops
        designed to guide you through the intricacies of these machines,
        ensuring that you can unleash their full potential with confidence and
        skill. Come and explore the fascinating world of 3D printing with us!
        🖨️🌟🔧🛠️🚀
      </>
    ),
  },
  {
    picture: LaserEngraving,
    title: "Laser Engraving & Cutting",
    tag: "Laser Engraving & Cutting",
    details:
      "Our xTool laser cutters allow participants to safely engrave and cut wood, leather, acrylic, and more. An interactive introduction to precision design and fabrication using modern tools.",
    popup: (
      <>
        What Awaits You:
        <ul>
          <li>
            <strong>Precision Craftsmanship: </strong>
            Achieve intricate and precise designs on various materials,
            elevating them into unique pieces of art with unparalleled accuracy.
          </li>
          <li>
            <strong>Explore the possibilities: </strong>
            Craft personalized gifts, custom signage, and decorative items! Set
            your innovative spirit free as you experiment with different
            materials and techniques, allowing your creative visions to shine
            through.
          </li>
          <li>
            <strong>Expert Guidance: </strong>
            Join our workshops and receive expert guidance to master the art of
            laser engraving, ensuring your projects reach their full potential.
          </li>
        </ul>
      </>
    ),
  },

  {
    picture: ScreenPrinting, // Service1Image,
    title: "Sublimation & Heat Press",
    tag: "Sublimation & Heat Press",
    details:
      " Sublimation printing paired with our heat press enables kids to apply their artwork to t-shirts, tote bags, mugs, and other surfaces—turning creative ideas into lasting keepsakes or gifts.",
    popup: (
      <>
        What's in Store:
        <ul>
          <li>
            <strong>Vibrant Personalization: </strong>
            Transform everyday items into personalized masterpieces with
            full-color, high-quality designs.
          </li>
          <li>
            <strong>Professional Results: </strong>Our heat press ensures
            professional-grade results, with crisp and lasting prints that stand
            out.
          </li>
          <li>
            <strong>Guided Workshops: </strong> Learn the ins and outs of
            sublimation printing through our guided workshops, allowing you to
            become confident with sublimation!
          </li>
        </ul>
      </>
    ),
  },

  {
    picture: Service3Image,
    title: "Robotics & Electronics",
    tag: "Robotics & Electronics",
    details:
      "Kids can explore circuits, sensors, and simple code through STEM kits and guided builds. Projects encourage problem-solving, experimentation, and teamwork—making tech feel exciting and accessible.",
    popup: (
      <>
        What we offer:
        <ul>
          <li>
            <strong>Circuitry Exploration: </strong> Delve into the fascinating
            realm of circuitry, where you can design and experiment with
            electronic connections, unlocking endless possibilities.
          </li>
          <li>
            <strong> STEM Kits: </strong>
            We offer quickstart STEM kits suitable for everyone, from beginners
            taking their first steps into this exciting world to advanced
            tinkerers seeking new challenges.
          </li>
          <li>
            <strong> Innovative Machines & robots: </strong>
            Create cutting-edge machines & robots that showcase your ingenuity
            and technical prowess, pushing the boundaries of innovation.
          </li>
        </ul>
      </>
    ),
  },

  {
    picture: SewingStation,
    title: "Sewing Station",
    tag: "Sewing Station",
    details:
      "Our sewing machines make it easy for children to learn sewing basics while creating their own pillows, costumes, accessories or fashion items. Sergers are also available for finishing touches and introducing more advanced techniques in a beginner-friendly setting.",
    popup: (
      <>
        What we offer:
        <ul>
          <li>
            Professional Cameras: Access high-quality cameras that are favored
            by seasoned photographers, allowing you to capture every detail with
            precision.
          </li>
          <li>
            Expert Lighting: Illuminate your subjects with expertly designed
            lighting setups that ensure your photos are beautifully lit and
            visually stunning.
          </li>
          <li>
            Versatile Backdrops: Choose from selection of backdrops to set the
            perfect scene for your photos, creating the ambiance and mood you
            desire.
          </li>
          <li>
            Photography Boxes: For product and macro photography, our
            photography boxes provide controlled lighting and composition,
            resulting in captivating images.
          </li>
        </ul>
        Whether you're an amateur or a pro, our Photography Studio offers the
        ideal environment to explore your creativity and develop your
        photography skills.
      </>
    ),
  },

  {
    picture: Circuit, // Service7Image,
    title: "Cricut Design Station",
    tag: "Cricut Design Station",
    details:
      " Using our Cricut machine, kids can create personalized stickers, iron-ons, cards, and more. It’s a fun and approachable way to explore digital crafting and design.",
    popup: (
      <>
        What Awaits You:
        <ul>
          <li>
            <strong>Precision Cutting: </strong>
            Harness the power of precision cutting to create intricate designs,
            custom apparel, unique home decor, and more with ease.
          </li>
          <li>
            <strong>Versatile Materials: </strong>
            From paper and vinyl to fabric and leather, the Cricut Machine
            handles a wide range of materials, allowing you to experiment and
            explore.
          </li>
          <li>
            <strong>Design Freedom: </strong>
            Bring your unique ideas to life by designing your own projects or
            selecting from a vast library of pre-made designs and templates.
          </li>
          <li>
            <strong>User-Friendly: </strong>
            The Cricut Machine is user-friendly and suitable for crafters of all
            levels, ensuring an enjoyable and seamless creative process.
          </li>
          <li>
            <strong>Inspiration and Innovation: </strong>
            Join our workshops and crafting community to share ideas, learn new
            techniques, and stay inspired on your crafting journey.
          </li>
        </ul>
      </>
    ),
  },

  {
    picture: WoodWorking, // Service7Image,
    title: "Woodworking",
    tag: "Woodworking",
    details:
      "With real tools like hammers, nails, sandpaper, and kid-friendly hand tools, participants gain hands-on experience and practical skills. A supervised lathe is also available for special projects, introducing the basics of safe tool use and design.",
    popup: (
      <>
        What You Can Expect:
        <ul>
          <li>
            <strong>Equipment: </strong>
            Access a wide array of woodworking tools and machinery
          </li>
          <li>
            <strong>Endless Possibilities: </strong>
            Dive into an expansive world of possibilities, from crafting
            furniture and intricate woodwork to personalized home decor and
            more.
          </li>
          <li>
            <strong>Expert Guidance: </strong>
            Join our woodworking workshops and receive guidance from experienced
            craftsmen, ensuring your projects are not only creative but also
            safe and well-executed.
          </li>
          <li>
            <strong>Collaborative Environment:</strong>
            Connect with fellow woodworkers, share ideas, and collaborate on
            projects in a supportive and inspiring atmosphere.
          </li>
          <li>
            <strong>Safety First: </strong>
            We prioritize safety in our Woodshop, providing the necessary
            training and safety measures to ensure a secure and enjoyable
            woodworking experience.
          </li>
        </ul>
      </>
    ),
  },

  {
    picture: PaintingAndDrawing,
    title: "Painting & Drawing",
    tag: "Painting & Drawing",
    details:
      "Fully stocked with paints, pencils, clay, canvases, and more, we invite children to explore new techniques through both guided and open-ended art activities. These experiences inspire creativity, encourage self-expression, and help build confidence.",
    popup: (
      <>
        <ul>
          <li>
            <strong>Artistic Supplies: </strong>
            Explore a wide array of art materials, from paints to brushes, pens,
            pencils, paper, and canvases, providing you with ample resources to
            fuel your creativity.
          </li>
          <li>
            <strong>Creative Freedom: </strong>
            Embrace the liberty to experiment with various mediums and
            techniques, allowing your artistic journey to evolve naturally.
          </li>
          <li>
            <strong> Inspiring Ambiance: </strong>
            Immerse yourself in a well-lit and creatively adorned space,
            designed to cultivate an atmosphere where your creative spirit can
            flourish.
          </li>
          <li>
            <strong>Guided Learning: </strong>
            Participate in art classes and workshops led by talented
            instructors, ready to assist you in mastering various techniques and
            honing your skills.
          </li>
          <li>
            <strong>Flexible Studio Time: </strong>
            Enjoy the convenience of accessing the arts studio during all open
            hours, enabling you to work at your own pace and schedule, whenever
            inspiration strikes.
          </li>
          <li>
            <strong>Artistic Community: </strong>
            Connect with fellow artists, fostering a sense of camaraderie, and
            engage in collaborative projects that inspire and elevate your work.
          </li>
          <li>
            <strong>Inclusive Atmosphere: </strong>
            Whether you're a beginner seeking guidance or a seasoned artist
            looking for a space to explore, our studio offers an inclusive and
            supportive environment for artists of all backgrounds and expertise
            levels.
          </li>
        </ul>
      </>
    ),
  },

  {
    picture: ComputerLab,
    title: "Computers & Design Software",
    tag: "Computers & Design Software",
    details:
      "Our computers come equipped with industry-standard programs like Adobe Creative Suite and Canva, offering opportunities to explore graphic design, animation, video editing, and digital art in a supportive, project-based environment.",
    popup: (
      <>
        What we offer:
        <ul>
          <li>
            <strong>Professional Suite: </strong> Access a complete suite of
            industry-standard editing and design software that empowers you to
            bring your projects to life with precision and finesse.
          </li>
          <li>
            <strong>Video Editing: </strong>
            Seamlessly edit videos, add effects, and fine-tune audio to create
            captivating visual stories that leave a lasting impact.
          </li>
          <li>
            <strong>Graphic Design: </strong>
            Dive into graphic design projects with the confidence that our
            computers can handle intricate illustrations, layouts, and photo
            enhancements.
          </li>
          <li>
            <strong>Development Opportunities: </strong>
            For those with a passion for coding and development, our computers
            provide the horsepower you need to bring digital dreams to life.
          </li>
          <li>
            <strong>3D Modeling: </strong>
            Explore the world of 3D modeling and bring your imagination to life
            by crafting intricate three-dimensional designs and creations.
          </li>
        </ul>
        Be sure to browse through our class schedule to discover a range of
        informative workshops focused on harnessing the potential of advanced
        software available at Creator Zone.
      </>
    ),
  },

  {
    picture: Photography,
    title: "Photography Studio",
    tag: "Photography Studio",
    details:
      " With Canon DSLR cameras, professional lighting, backdrops, and a green screen, youth (13+) can explore photography and visual storytelling—learning the basics of photo composition, editing, and digital effects.",
    popup: (
      <>
        What we offer:
        <ul>
          <li>
            Professional Cameras: Access high-quality cameras that are favored
            by seasoned photographers, allowing you to capture every detail with
            precision.
          </li>
          <li>
            Expert Lighting: Illuminate your subjects with expertly designed
            lighting setups that ensure your photos are beautifully lit and
            visually stunning.
          </li>
          <li>
            Versatile Backdrops: Choose from selection of backdrops to set the
            perfect scene for your photos, creating the ambiance and mood you
            desire.
          </li>
          <li>
            Photography Boxes: For product and macro photography, our
            photography boxes provide controlled lighting and composition,
            resulting in captivating images.
          </li>
        </ul>
        Whether you're an amateur or a pro, our Photography Studio offers the
        ideal environment to explore your creativity and develop your
        photography skills.
      </>
    ),
  },

  {
    picture: VirtualReality,
    title: "Virtual Reality Lab",
    tag: "Virtual Reality Lab",
    details:
      " Our Meta Quest headsets provide immersive educational experiences in a safe, supervised setting. Youth (13+) can explore virtual worlds, design in 3D, and engage with future-forward technology in a fun and meaningful way.",
    popup: (
      <>
        What Awaits You:
        <ul>
          <li>
            Immersive Exploration: Dive into immersive experiences that
            transport you to otherworldly realms, all through the power of
            virtual reality.
          </li>
          <li>
            Create Your Own Worlds: Learn the art of crafting your very own VR
            environments, where you become the architect of unique digital
            landscapes.
          </li>
          <li>
            Cutting-Edge Technology: Explore the latest advancements in VR
            technology, pushing the boundaries of what's possible in the digital
            realm.
          </li>
          <li>
            Endless Adventure: With virtual reality, the adventure is boundless,
            limited only by your imagination and creativity.
          </li>
        </ul>
      </>
    ),
  },

  // {
  //   picture: CollabSpace,
  //   title: "Co-Working & Collaborative spaces",
  //   tag: "Co-Working & Collaborative spaces",
  //   details:
  //     "Our Shared Community Tables are more than just a place to work; they're the epicenter of collaboration, where the power of collective creativity is unleashed. Here, individuals from diverse backgrounds and disciplines converge, driven by a common purpose: to bring innovative ideas and projects to fruition through the magic of collaboration.",
  //   popup: (
  //     <>
  //       <ul>
  //         <li>
  //           <strong>Diverse Perspectives: </strong>
  //           Our shared tables are a melting pot of diverse talents and
  //           expertise, sparking innovative thinking. Here, artists mingle with
  //           engineers, writers collaborate with designers, and dreamers unite to
  //           shape the future.
  //         </li>
  //         <li>
  //           <strong>Positive Energy: </strong>
  //           There's a unique energy when kindred spirits gather to tackle
  //           challenges, explore uncharted territories, and craft remarkable
  //           creations. It's a magnetic force that propels projects forward,
  //           driven by shared enthusiasm.
  //         </li>
  //         <li>
  //           <strong>Supportive Community: </strong>
  //           Beyond the tables, you'll discover a supportive ecosystem where
  //           constructive feedback, mentorship, and a genuine desire for each
  //           other's success are the norm. It's a place where everyone thrives
  //           together.
  //         </li>
  //         <li>
  //           <strong>Inspirational Setting: </strong>
  //           Our surroundings are carefully designed to inspire. Surrounded by
  //           accessible art supplies, sewing machines, printers, and cozy nooks,
  //           your collaborative spirit finds the nourishment it needs, and your
  //           ideas find fertile ground.
  //         </li>
  //       </ul>
  //     </>
  //   ),
  // },
  {
    picture: Podcast,
    title: "Audio Recording",
    tag: "Audio Recording",
    details:
      "Unleash your inner podcaster, storyteller, or vocalist with our audio recording setup, featuring RØDE microphones and beginner-friendly editing software. Youth (13+) can explore voice recording, sound design, and audio production—discovering their voice, sharing their stories, and bringing creative ideas to life. 🎧",
    popup: (
      <>
        <ul>
          <li>
            <strong>Soundproof Sanctuary: </strong> Enjoy a quiet and
            distraction-free environment where your creative ideas can flow
            without interruption.
          </li>
          <li>
            <strong> Modern Equipment: </strong>
            Access top-of-the-line audio and video equipment that ensures your
            recordings are of the highest quality.
          </li>
          <li>
            <strong>Clarity: </strong>
            Experience the power of precise and crystal-clear sound, allowing
            your creative endeavors to shine.
          </li>
          <li>
            <strong> Guidance and Expertise: </strong>
            Benefit from our workshops and expert guidance to make the most of
            our recording studios, whether you're a seasoned pro or just
            starting out.
          </li>
        </ul>
      </>
    ),
  },
];

const SignUpCard = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await postUserInfo({ email });
      setIsLoading(false);
      if (res?.ok) {
        setEmail("");
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false);
    }
  };
  return (
    <form onSubmit={handleSubmit} className="servicesSec_signUpCard">
      <h3>Get the latest updates for our services</h3>
      <input
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        type="email"
        placeholder="Add your email address"
        required
      />
      <Button disabled={isLoading} type="submit" white>
        {isLoading ? "Signing up..." : "Sign me up"}
      </Button>
    </form>
  );
};

const MobileServicesCards = forwardRef(
  ({ setActiveSlide, handleServiceClick }, ref) => {
    const settings = {
      className: "slider",
      dots: true,
      infinite: false,
      slidesToShow: 2.2,
      slidesToScroll: 2,
      initialSlide: 2,
      arrows: false,
      afterChange: (next) => {
        setActiveSlide(
          next > ServicesData.length - 2
            ? ServicesData.length - 1
            : parseInt(next)
        );
      },

      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.7,
            slidesToScroll: 1,
            initialSlide: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.3,
            slidesToScroll: 1,
          },
        },
      ],
    };
    return (
      <div className="mobileServicesCarousel">
        <Slider ref={ref} {...settings}>
          {ServicesData.map((d, i) => (
            <div
              key={i}
              // onClick={() => handleServiceClick(i)}
              className="servicesSec_service"
            >
              <div>
                <img src={d.picture} alt="service" loading="lazy" />
                <div>
                  <h3>{d.title}</h3>
                  <p>{d.details}</p>
                </div>
              </div>
              {/* <img
                className="servicesSec_serviceArrow"
                src={LongRightArrow}
                alt="arrow"
              /> */}
            </div>
          ))}
        </Slider>
        {/* <SignUpCard /> */}
      </div>
    );
  }
);

const Tags = ({ activeSlide, handleTagClick }) => {
  return (
    <div className="servicesSec_tags">
      {ServicesData.map((d, i) => (
        <span
          key={i}
          className={`${activeSlide === i ? "servicesSec_tagActive" : ""}`}
          onClick={() => handleTagClick(i)}
        >
          {d.tag}
        </span>
      ))}
    </div>
  );
};

const ServicesSec = () => {
  const sliderRef = useRef();

  const [servicesModal, setServicesModal] = useState(false);
  const [currentServiceModal, setCurrentServiceModal] = useState(0);

  const [activeSlide, setActiveSlide] = useState(0);

  const handleTagClick = (index) => {
    sliderRef.current.slickGoTo(index);
    setActiveSlide(index);
  };

  const handleServiceClick = (index) => {
    setCurrentServiceModal(index);
    setServicesModal(true);
  };

  return (
    <>
      <ServicesPopup
        data={ServicesData}
        isOpen={servicesModal}
        setIsOpen={setServicesModal}
        currentServiceModalIndex={currentServiceModal}
        setCurrentServiceModalIndex={setCurrentServiceModal}
      />
      <section id="services" className="servicesSec">
        <div className="servicesSec_images">
          <img src={ServiceBlue1} alt="blue1" className="servicesSec_blue1" />
          <img src={ServiceBlue2} alt="blue2" className="servicesSec_blue2" />
          <img src={ServiceBlue3} alt="blue3" className="servicesSec_blue3" />
          <img
            src={ServiceBlueLine}
            alt="blue3"
            className="servicesSec_blueLine"
          />
        </div>
        <ServicesCarousel />
        <div className="servicesSec_titleContainer">
          <div>
            <small>
              What’s a part of my membership? Full access to ALL of the below!
            </small>
            <h3>Maker Labs</h3>
          </div>
          <p>
            At Creator Zone, we use a variety of tools and technology to inspire
            creativity and practical learning. Here’s a look at some of the labs
            available to help students explore, design, and innovate.
            🌟🎥🖨️🛠️🪡🎨
          </p>
        </div>
        <Tags
          activeSlide={activeSlide}
          handleTagClick={handleTagClick}
          setActiveSlide={setActiveSlide}
        />
        <div className="servicesSec_services">
          {ServicesData.map((d, i) => (
            <div
              key={i}
              // onClick={() => handleServiceClick(i)}
              className="servicesSec_service"
            >
              <div>
                <img src={d.picture} alt="service" loading="lazy" />
                <h3>{d.title}</h3>
                <p>{d.details}</p>
              </div>
              {/* <img
                className="servicesSec_serviceArrow"
                src={LongRightArrow}
                alt="arrow"
              /> */}
            </div>
          ))}
          {/* <SignUpCard /> */}
        </div>
        <MobileServicesCards
          handleServiceClick={handleServiceClick}
          setActiveSlide={setActiveSlide}
          ref={sliderRef}
        />
      </section>
    </>
  );
};

export default ServicesSec;
